export enum EApplicationUrls {
  APPLICATION = 'application',
  ANIMALS = 'animals',
  APPROVE = 'approve',
  REJECT = 'reject',
  DETAILS = 'details',
  VERIFY = 'verify',
  EXPORT = 'export',
}
